export default "__VITE_ASSET__BwVPuD9s__"